import { SkeletonLoaderModule } from '../skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CompaniesComponent } from './companies.component';

@NgModule({
    declarations: [
        CompaniesComponent
    ],
    imports: [
        SkeletonLoaderModule,
    CommonModule,
        FormsModule
    ],
    exports: [
        CompaniesComponent
    ],
    entryComponents: [CompaniesComponent]
})
export class CompaniesModule { }
